import { useTranslation } from 'next-i18next/pages';
import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';

import { PaginationSortField } from '@pflegia/types/common/job-position/pagination-sort-field';
import { useJobListSortStore } from '@pflegia/ui/hooks/use-sort';
import { ReactComponent as Briefcase } from '@pflegia/ui/icons/briefcase.svg';
import { JOBS } from '@pflegia/ui/pflegia/constants/routes';
import { normalizeJobsParams } from '@pflegia/util/common/normalize-jobs-params';

const JOBS_ROUNDING = 10;
const MIN_JOB_COUNT_FALLBACK = 10;

interface DemandGapCardProps {
  city: string;
  imageSrc: string;
  fallbackImageSrc?: string;
  jobCount: number;
}

const DemandGapCard = ({ city, imageSrc, fallbackImageSrc, jobCount }: DemandGapCardProps) => {
  const { t } = useTranslation(['common', 'landingPage']);
  const { setSort } = useJobListSortStore();
  const [currentSrc, setCurrentSrc] = useState<string>(imageSrc);

  const displayJobCount = Math.max(Math.floor(jobCount / JOBS_ROUNDING) * JOBS_ROUNDING, MIN_JOB_COUNT_FALLBACK);

  return (
    <Link
      href={`${JOBS}/${normalizeJobsParams(city)}`}
      onClick={() => setSort(PaginationSortField.Salary)}
      className='flex h-35.25 overflow-hidden rounded-2xl border border-blue-100 bg-white shadow-2xl'>
      <Image
        alt=''
        className='h-full w-36 shrink-0 object-cover'
        src={currentSrc}
        height={141}
        width={144}
        onError={() => fallbackImageSrc && setCurrentSrc(fallbackImageSrc)}
      />
      <div className='flex min-w-0 flex-col justify-center gap-2 px-4 lg:px-6'>
        <h3 className='text-default text-2xl'>{city}</h3>
        <p className='text-funnel-blue flex items-center gap-2 text-xl whitespace-nowrap'>
          <Briefcase className='shrink-0' width={24} height={24} />
          {t('landingPage:demandGapCluster.jobsCount', { count: displayJobCount })}
        </p>
      </div>
    </Link>
  );
};

export default DemandGapCard;
